<div class="routing-rule-destination routing-rule-settings">
  <div class="source-data-container">
    <ac-input-container label="Prefixes / Prefix Groups">
      <ac-select class="single-row"
                 [(acModel)]="destination.rrAttrs.prefix"
                 (acModelChange)="updateLogicalConjunctionNotice()"
                 [multiple]="true"
                 [addCustomTags]="true"
                 [items]="prefixGroups"
                 bindLabel="name"
                 [bindValue]="null"
                 [combinedMode]="true"
                 [allowClear]="true">
      </ac-select>
    </ac-input-container>

    <ac-input-container label="Hosts">
      <ac-select class="single-row"
                 [(acModel)]="destination.rrAttrs.host"
                 (acModelChange)="updateLogicalConjunctionNotice()"
                 [multiple]="true"
                 [searchable]="false"
                 [addCustomTags]="true"
                 [bindLabel]="null"
                 [bindValue]="null"
                 [allowClear]="true">
      </ac-select>
    </ac-input-container>

    <ac-input-container label="User Groups">
      <ac-select class="single-row"
                 [(acModel)]="destination.userGroups"
                 (acModelChange)="updateLogicalConjunctionNotice()"
                 [multiple]="true"
                 [items]="userGroups"
                 [bindLabel]="'name'"
                 [bindValue]="'id'"
                 [allowClear]="true">
      </ac-select>
    </ac-input-container>

    <ac-input-container label="Customers">
      <ac-select class="single-row"
                 [(acModel)]="destination.destCustomers"
                 (acModelChange)="updateLogicalConjunctionNotice()"
                 alternativeName="destination.destCustomers"
                 [ngDisabled]="destination.allCustomers"
                 [multiple]="true"
                 [items]="customers"
                 [bindLabel]="'name'"
                 [bindValue]="'id'"
                 [allowClear]="true">
      </ac-select>
    </ac-input-container>

    <!--<div>
      <ac-checkbox class="customers"
                   labelText="Use All Customers"
                   [(acModel)]="destination.allCustomers"
                   (acModelChange)="updateLogicalConjunctionNotice()">
      </ac-checkbox>
    </div>-->

    <mat-checkbox name="enableDate" color="primary" (change)="updateLogicalConjunctionNotice()"
                  [(ngModel)]="destination.allCustomers">Use All Customers</mat-checkbox>

    <div class="logical-conjunction-notice" [innerHTML]="logicalConjunctionNotice"></div>
  </div>
  <div class="map-container">

  </div>
</div>
